import * as FloatingUI from "@floating-ui/dom"
import * as Log from "web-ui/log"

export function DropdownPlacementPlugin() {
  const tomSelect = this

  const dropdownOffset = 8
  const windowPadding = 8

  let currentPlacement

  let maximumContentHeight

  let disableAutoUpdate

  tomSelect.hook("instead", "positionDropdown", () => {
    if (!tomSelect.isOpen) {
      return Promise.resolve()
    }

    return updatePosition()
  })

  tomSelect.hook("after", "setup", () => {
    tomSelect.refreshOptions(false)

    const dropdownContent = tomSelect.dropdown_content
    maximumContentHeight = parseFloat(getComputedStyle(dropdownContent).maxHeight)
  })

  const sizeMiddleware = FloatingUI.size({
    padding: windowPadding,
    apply: ({ availableHeight, elements }) => {
      const dropdownContent = tomSelect.dropdown_content

      const dropdown = elements.floating
      const dropdownOffsetHeight = dropdown.offsetHeight
      const dropdownContentOffsetHeight = dropdownContent.offsetHeight
      const maximumDropdownHeight = dropdownOffsetHeight - dropdownContentOffsetHeight + maximumContentHeight

      const overflow = maximumDropdownHeight - availableHeight

      debug("Resize", { availableHeight, overflow, maximumDropdownHeight })

      if (overflow >= 0) {
        const newContentHeight = maximumContentHeight - overflow
        debug("Resizing", { newContentHeight })

        dropdownContent.style.setProperty("max-height", `${newContentHeight}px`)
      } else {
        dropdownContent.style.removeProperty("max-height")
      }
    }
  })

  tomSelect.on("load", () => {
    const config = {
      placement: currentPlacement,
      middleware: [
        FloatingUI.offset(dropdownOffset),
        sizeMiddleware
      ]
    }

    updatePosition(config)
  })

  tomSelect.on("dropdown_open", () => {
    disableAutoUpdate = FloatingUI.autoUpdate(
      tomSelect.control,
      tomSelect.dropdown,
      () => updatePosition(),
      { elementResize: false }
    )
  })

  tomSelect.on("dropdown_close", () => {
    if (disableAutoUpdate) {
      disableAutoUpdate()
      disableAutoUpdate = null
    }

    tomSelect.lastQuery = null
    tomSelect.refreshOptions(false)

    removeDropdownStyles()
  })

  function updatePosition(config) {
    if (!config) {
      config = {
        placement: "bottom",
        middleware: [
          FloatingUI.offset(dropdownOffset),
          FloatingUI.flip({ padding: windowPadding }),
          sizeMiddleware
        ]
      }
    }

    return FloatingUI.computePosition(
      tomSelect.control,
      tomSelect.dropdown,
      config
    ).then(({ placement, y }) => {
      currentPlacement = placement

      const controlRect = tomSelect.control.getBoundingClientRect()

      const left = controlRect.left + window.scrollX

      if (placement === "bottom") {
        const top = y

        placeDropdown({ left, top })

        tomSelect.dropdown.classList.remove("above")
      }

      if (placement === "top") {
        const bodyHeight = document.body.offsetHeight
        const rect = tomSelect.control.getBoundingClientRect()
        const scrollY = window.scrollY
        const scrollbarHeight = getScrollbarHeight()

        const bottom = bodyHeight - rect.top + dropdownOffset - scrollY - scrollbarHeight

        placeDropdown({ left, bottom })

        tomSelect.dropdown.classList.add("above")
      }
    })
  }

  function getScrollbarHeight() {
    const bodyStyle = window.getComputedStyle(document.body)
    const bodyOverflowY = bodyStyle.overflowY
    const hasHiddenOverflow = bodyOverflowY === 'hidden'

    if (!hasHiddenOverflow) {
      return 0
    }

    return document.documentElement.offsetHeight - document.documentElement.clientHeight
  }

  function placeDropdown(coordinates) {
    debug("Coordinates", coordinates)
    const { top, bottom, left } = coordinates

    tomSelect.dropdown.style.setProperty("left", `${left}px`)

    const controlWidth = tomSelect.control.offsetWidth
    tomSelect.dropdown.style.setProperty("min-width", `${controlWidth}px`)

    if (top !== undefined) {
      tomSelect.dropdown.style.setProperty("top", `${top}px`)
      tomSelect.dropdown.style.removeProperty("bottom")
    }

    if (bottom !== undefined) {
      tomSelect.dropdown.style.setProperty("bottom", `${bottom}px`)
      tomSelect.dropdown.style.removeProperty("top")
    }
  }

  function removeDropdownStyles() {
    tomSelect.dropdown.classList.remove("above")
  }

  function debug(message, data) {
    Object.assign(data, {
      id: tomSelect.input.id
    })

    Log.debug("Tom Select Dropdown Placement Plugin - " + message, data)
  }
}
